import Icon from '../assets/index'

const Sorting = ({ isEnabled, direction }) => {
  let icon = 'sort'

  if (isEnabled && direction === 'asc') {
    icon = 'arrowDropUp'
  }

  if (isEnabled && direction === 'desc') {
    icon = 'arrowDropdown'
  }

  return <Icon icon={icon} height='16' width='16' customClass={!isEnabled ? 'inactive' : ''} />
}

export default Sorting
